
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/van/campervan",
      function () {
        return require("private-next-pages/rims/van/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/van/campervan"])
      });
    }
  